import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const twoColumnBannerBackgroundColors = [
  BackgroundColor.STONE,
  BackgroundColor.PURPLE_LIGHT,
  BackgroundColor.LIME_LIGHT,
  BackgroundColor.MINT_LIGHT,
  BackgroundColor.PURPLE,
  BackgroundColor.MIDNIGHT_BLUE,
  BackgroundColor.TRANSPARENT,
  BackgroundColor.FADED_WHITE_FACET
] as const

export type TwoColumnBannerBackgroundColor =
  (typeof twoColumnBannerBackgroundColors)[number]
